module.exports = __webpack_public_path__ + "media/esophageal ca.d43be28f.wav";